import { css } from "@emotion/react"
import styled from "@emotion/styled"
import { ComponentProps, forwardRef } from "react"
import { BORDER_GREY_COLOR, DARK_BLUE_COLOR, RED_COLOR } from "theme/colors"
import { PX16 } from "theme/sizes"

export const Root = styled.div<{ hasError?: boolean }>`
  border-radius: 8px;
  font-size: ${PX16};
  font-family: inherit;
  line-height: 1;
  color: ${DARK_BLUE_COLOR};
  display: flex;
  align-items: center;
  background-color: white;

  &:focus,
  &:focus-within {
    border: rgb(94, 158, 214) solid 1px;
    outline: rgb(94, 158, 214) auto 1px;
    outline: -webkit-focus-ring-color auto 1px;
  }

  box-shadow:
    0px 1.5px 4px 0px rgba(0, 0, 0, 0.2) inset,
    0px 1.5px 2px 0px rgba(0, 0, 85, 0.02) inset,
    0px 0px 0px 1px rgba(0, 9, 50, 0.12) inset;

  &:hover {
    box-shadow:
      0px 0px 4px 0px rgba(128, 126, 165, 0.5),
      0px 1.5px 4px 0px rgba(0, 0, 0, 0.2) inset,
      0px 1.5px 2px 0px rgba(0, 0, 85, 0.02) inset,
      0px 0px 0px 1px rgba(0, 9, 50, 0.12) inset;
  }

  &:focus {
    box-shadow:
      0px 0px 4px 0px rgba(79, 77, 132, 0.5),
      0px 1.5px 4px 0px rgba(0, 0, 0, 0.2) inset,
      0px 1.5px 2px 0px rgba(0, 0, 85, 0.02) inset,
      0px 0px 0px 1px rgba(0, 9, 50, 0.12) inset;
  }

  ${({ hasError }) =>
    hasError &&
    css`
      border: 1px solid ${RED_COLOR};
      &:focus,
      &:hover {
        box-shadow:
          0px 0px 4px 0px rgba(175, 0, 23, 0.5),
          0px 1.5px 4px 0px rgba(0, 0, 0, 0.2) inset,
          0px 1.5px 2px 0px rgba(0, 0, 85, 0.02) inset,
          0px 0px 0px 1px rgba(0, 9, 50, 0.12) inset;
      }
    `}
`

export const Control = styled.textarea`
  appearance: none;
  padding: 21px 16px;
  font-size: inherit;
  font-family: inherit;
  color: inherit;
  border-radius: inherit;
  border: none;
  flex: 1;
  outline: 0px;
  background-color: unset;

  ::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: ${DARK_BLUE_COLOR};
    opacity: 0.5;
  }
`

const TextAreaControl = styled(Control)`
  height: 126px;
  width: 100%;
  box-sizing: border-box;
`.withComponent("textarea")

const TextArea = forwardRef<
  HTMLTextAreaElement,
  ComponentProps<typeof TextAreaControl>
>(({ children, value, onChange, ...props }, ref) => {
  return (
    <Root>
      <TextAreaControl value={value} onChange={onChange} ref={ref} {...props} />
    </Root>
  )
})

TextArea.displayName = "TextArea"

export default TextArea
